import { Injectable } from '@angular/core';
import { TypeChangementEnum } from '../../constantes/type-changement.enum';
import { CybermetrieService, Evenement } from '@oel/js-cybermetrie';

@Injectable({
  providedIn: 'root',
})
export class CybermetrieCoordonneesService {
  constructor() {}

  envoyerEvenementPersonnalise(
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    value?: number,
    type?: string,
    champExtra?: Map<string, string>
  ): void {
    if (eventCategory !== null && eventAction !== null && eventLabel !== null) {
      let typeModification = '';
      if (type) {
        switch (type) {
          case TypeChangementEnum.COORDONNEES:
            typeModification = 'adresse principale';
            break;
          case TypeChangementEnum.COURRIEL:
            typeModification = 'courriel';
            break;
          case TypeChangementEnum.TELEPHONE:
            typeModification = 'telephone';
            break;
          default:
            typeModification = 'adresse principale|telephone|courriel';
        }
      }

      let valeur = 0;
      if (value) {
        valeur = value;
      }

      CybermetrieService.envoyerEvenement(
        {
          event: Evenement.InterractionsPages,
          category: eventCategory,
          action: eventAction,
          label: eventLabel + typeModification,
          value: valeur,
          nonInteraction: false,
        },
        champExtra
      );
    }
  }
}
